/**
 * @generated SignedSource<<9672bb577e5f57d19cd951130d79e0c9>>
 * @relayHash 0c39e59e4aa1e302911c8a32aeb2d983
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bc4c6b2850d37cda46fb5f1b0760a83ba5c2a19cac79a71e09859d3266625b30

import type { ConcreteRequest } from 'relay-runtime';
export type RovoActivationQuery$variables = {
  cloudId: string;
};
export type RovoActivationQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly active: string | null;
    } | null;
  } | null> | null;
};
export type RovoActivationQuery = {
  response: RovoActivationQuery$data;
  variables: RovoActivationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "cloudIds.0",
            "variableName": "cloudId"
          }
        ],
        "kind": "ListValue",
        "name": "cloudIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "product",
            "value": "rovo"
          }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "active"
          }
        ],
        "storageKey": "activationIdByProduct(product:\"rovo\")"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RovoActivationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RovoActivationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0c39e59e4aa1e302911c8a32aeb2d983",
    "id": "bc4c6b2850d37cda46fb5f1b0760a83ba5c2a19cac79a71e09859d3266625b30",
    "metadata": {},
    "name": "RovoActivationQuery",
    "operationKind": "query",
    "text": "query RovoActivationQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){activationIdByProduct(product:\"rovo\"){active}}}"
  }
};
})();

(node as any).hash = "b7f5c5c652d7a1497de8e5913a025207";

export default node;
